import React, { createContext, useReducer, useContext } from 'react';
import { object, func, any } from 'prop-types';

const AppContext = createContext();

export function AppStateProvider({ reducer, initialState = {}, children }) {
  const value = useReducer(reducer, initialState);

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
}

AppStateProvider.propTypes = {
  reducer: func,
  initialState: object,
  children: any,
};

export function useAppState() {
  return useContext(AppContext);
}
